export default "__VITE_ASSET__3b23631a__"